import { IIconStyle } from '../models/index.js';
export const iconStyle: IIconStyle = {
	children: {
		wrapper: {
			display: 'flex',
			flex: {
				direction: 'column',
			},
			justifyContent: 'center',
			overrides: [
				{
					selector: '[data-selector="base-icon"]',
					style: {
						verticalAlign: 'middle',
					},
				},
			],
		},
	},
};
